import { useState } from 'react';
import { Modal } from '@mantine/core';
import useUploadAsset from '../../helpers/useUploadAsset';
import AssetForm from '../Assets/AssetForm';
import ErrorMessage from '../ErrorMessage';

const AiChatDocumentsModal = ({ documentsModalOpen, toggleDocumentsModal, addFile }) => {
  const [userError, setUserError] = useState();

  const { uploadDocument } = useUploadAsset(setUserError);

  return (
    <Modal opened={documentsModalOpen} onClose={() => toggleDocumentsModal()} title="Upload a Document to Extract It's Context">
      <AssetForm
        asset={{ title: '', description: '', url: '' }}
        saveAsset={(asset, file) =>
          uploadDocument(asset, file, (assetUrl) => {
            addFile(asset.title, assetUrl);
            toggleDocumentsModal();
          })
        }
        closeModal={toggleDocumentsModal}
      />
      {userError && <ErrorMessage message={userError.message} />}
    </Modal>
  );
};

export default AiChatDocumentsModal;
